export const BASE_FONT_SCALE = 75; // 16px * 0.75 = 12px

export const MAX_FONT_SCALE = 112.5; // 16px * 1.125 = 18px

export const DVB_PREFIX = 'dvb';

export const NEXTUI_CSS_PREFIX = DVB_PREFIX; // Default is nextui

export const LOCAL_STORAGE_KEY_SKIP_INSTALL = 'IS_SKIP_INSTALL';

export const NO_TRANSITION_CLASS_NAME = 'no-transition';

// If you edit the class name, please also update index.html
export const DARK_MODE_CLASS_NAME = 'dark';

export const TABLET_MIN_WIDTH = 768;
